import * as tslib_1 from "tslib";
import CategoryRow from './CategoryRow';
import createNewCategoryRow from '../actions/createNewCategoryRow';
import store from '../store/store';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';
import { getMasterCategoryList } from 'owa-categories';
import { OptionDescription } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var styles = require('./CategoriesFull.scss');
var classNames = require('classnames/bind').bind(styles);
var CategoriesFull = /** @class */ (function (_super) {
    tslib_1.__extends(CategoriesFull, _super);
    function CategoriesFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onCreateNewCategory = function (ev) {
            createNewCategoryRow();
        };
        return _this;
    }
    CategoriesFull.prototype.render = function () {
        var newCategory = this.props.newCategory;
        var masterList = getMasterCategoryList();
        var categoryRowsToRender = [];
        // Render the row for new category
        if (newCategory.Id) {
            categoryRowsToRender.push(React.createElement(CategoryRow, { key: 'new_categoryRow', id: newCategory.Id, isNewCategoryRow: true, name: newCategory.Name, colorId: newCategory.Color.toString() }));
        }
        // Render master category list in reverse order, so the latest category always shows on top
        for (var i = masterList.length - 1; i >= 0; i--) {
            var categoryType = masterList[i];
            categoryRowsToRender.push(React.createElement(CategoryRow, { key: categoryType.Id, id: categoryType.Id, isNewCategoryRow: false, name: categoryType.Name, colorId: categoryType.Color.toString() }));
        }
        return (React.createElement("div", null,
            React.createElement(OptionDescription, { className: styles.emptyRules }, strings.options_categories_description_general),
            React.createElement(ActionButton, { className: styles.createCategoryButton, onClick: this.onCreateNewCategory, text: strings.options_create_category, iconProps: {
                    iconName: "Add" /* Add */,
                    styles: {
                        root: classNames(styles.icon, 'flipForRtl'),
                    },
                } }),
            categoryRowsToRender));
    };
    CategoriesFull = tslib_1.__decorate([
        reactive({
            newCategory: function () { return store.newCategory; },
        })
    ], CategoriesFull);
    return CategoriesFull;
}(React.Component));
export default CategoriesFull;
//# sourceMappingURL=CategoriesFull.js.map